import React, {Component} from "react";
import RequestList from "../components/RequestList";
import RequestCreate from "../components/RequestCreate";
import { connect } from "react-redux";

import order from '../static/files/order.pdf'

// import {ActionsRules} from '../const/action_rules';

class MainPage extends Component {

  constructor(props) {
    super(props);
  }

  render = () => (
    <div className='content'>
      <h2 className='content__title'>Сервис экспертизы для включения в реестр МТК</h2>
      <div className='line'/>
      {this.props.mode === 'working' && (
        <div className='container-fluid nopad'>
          <h4>Оформление заявки на МТК</h4>
          <RequestCreate />
        </div>
      )}
      {this.props.mode === 'suspended' && (
        <div className='container-fluid nopad'>
          <p style={{color: 'red'}}>Приём заявок временно приостановлен</p>
          <a className="btn-link" target="_blank" href={order}>Приказ</a>
        </div>
      )}
      <div className='line'/>

      {/* // TODO: Mainpage alert messages if needed
      typeof this.props.user !== 'undefined'
      && this.props.forms.findIndex(item => item.form_status=== 18) > -1
      && this.props.user.userRole === 'user'
      && (
        <div className='container-fluid nopad'>
          <div className='main-alert' dangerouslySetInnerHTML={{ __html: ActionsRules['user'][18].mainPageAlert }} />
        </div>
      ) */}

      <div className='container-fluid nopad'>
        <h4>Все заявки</h4>
        <RequestList />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    mode: state.forms.mode,
    user: state.forms.user,
    forms: state.forms.forms,
  };
}

export default connect(mapStateToProps)(MainPage);
